const SVGComponent = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.000000pt"
        height="15.000000pt"
        viewBox="0 0 86.000000 90.000000"
        preserveAspectRatio="xMidYMid meet"
        className="obituary-flower-icon"
    >
        <g
            transform="matrix(0.120514, 0, 0, -0.120514, -7.967251, 96.132835)"
            fill="#3182ce"
            stroke="none"
            className="obituary-flower-icon"
        >
            <path d="M 378 773 C 316 702 284 497 324 422 C 343 385 393 350 427 350 C 456 350 514 401 530 440 C 546 478 538 616 516 686 C 488 774 418 818 378 773 Z M 448 730 C 478 702 413.867 622.097 413.867 536.097 C 413.867 451.097 491 426 448 404 C 419 389 512.223 407.074 487.223 426.074 C 444.223 458.074 438.775 467.047 444.775 544.047 C 450.775 626.047 449.721 702.084 473.721 729.084 C 494.721 753.084 421 755 448 730 Z" />
            <path d="M292 753 c-43 -16 -79 -198 -53 -274 13 -38 56 -97 65 -88 4 3 -1 23 -10 45 -20 49 -15 175 11 252 18 52 14 74 -13 65z" />
            <path d="M534 750 c-7 -7 -3 -31 13 -78 29 -86 30 -180 3 -241 -23 -51 -19 -62 11 -35 68 60 81 222 26 319 -24 42 -37 51 -53 35z" />
            <path d="M150 434 c0 -67 33 -118 133 -203 47 -39 87 -71 91 -71 3 0 6 27 6 59 l0 59 -74 46 c-75 47 -136 105 -136 131 0 7 -4 17 -10 20 -6 4 -10 -12 -10 -41z" />
            <path d="M 700 416 C 700 398 653 359 558 300 C 464 240 429 192 422 113 L 417 58 L 461 86 C 555 145 652 245 693 325 C 714 368 725 430 711 430 C 705 430 700 424 700 416 Z M 591 253 C 578 228 556.126 217.748 542.126 217.748 C 514.126 217.748 524.044 190.632 577.044 224.632 C 621.044 252.632 607 281 591 253 Z" />
            <path d="M400 248 l0 -83 25 44 c15 25 25 59 25 82 0 35 -3 39 -25 39 -25 0 -25 -1 -25 -82z" />
        </g>
    </svg>
)
export default SVGComponent
